"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toFormSGDto = exports.mapFormSGResponseToDomain = void 0;
const api_domain_1 = require("../../auth/auth-forwarder/formsg/common/api-domain");
/**
 * Maps FormSG answers to the given domain properties.
 *
 * If FormSG `fieldType` is `attachment`, the question `_id` is used instead.
 * This allows retrieval of the attached file using `ctx.request.files[_id]`
 */
const mapFormSGResponseToDomain = (Domain, formSGResponse, questionToDomainProp) => {
    const params = {};
    formSGResponse.responses
        .filter((response) => questionToDomainProp.has(response.question))
        .forEach((response) => {
        const propKey = questionToDomainProp.get(response.question);
        if (response.fieldType === "attachment") {
            params[propKey] = response._id;
            return;
        }
        const answer = response instanceof api_domain_1.SingleAnswerFormField ? response.answer : response.answerArray;
        params[propKey] = answer;
    });
    return new Domain(params);
};
exports.mapFormSGResponseToDomain = mapFormSGResponseToDomain;
const toFormSGDto = (dto) => ({
    formBody: JSON.stringify(dto),
});
exports.toFormSGDto = toFormSGDto;
//# sourceMappingURL=form-sg.js.map